import useStore from "../../../store"
import { useEffect, useState } from 'react'
import { useTranslation } from "react-i18next"
import GraphRangeSelector from "./GraphRangeSelector"
import CreditUtilizationGraph from "./CreditUtilizationGraph"
import AlertMessage from "../../common/AlertMessage"
import {
  AccordionItem,
  AccordionItemContent,
  AccordionItemTrigger,
  AccordionRoot,
} from "../../ui/accordion"
import { colors } from "../../../utilities/colors"

export default function CreditGraphContainer() {
  const { t } = useTranslation()
  const dealer = useStore((state) => state.dealer)
  const [isSuspended, setIsSuspended] = useState(false)

  useEffect(() => {
    if (dealer) {
      setIsSuspended(dealer.attributes['active-status'] === 'Suspended')
    }
  }, [dealer])

  if (isSuspended) {
    return (
      <div className="flex justify-center w-full my-4 lg:ml-2">
        <AlertMessage
          message="Please contact your Account Manager immediately"
          style="justify-center text-yellow !text-base"
        />
      </div>
    )
  }

  return(
    <div className="flex flex-col items-center w-full mb-2">
      {dealer &&
        <AccordionRoot collapsible bg={colors.grey900} borderRadius="md">
          <AccordionItem border='none'>
            <h2>
              <AccordionItemTrigger p={2}>
                <div className="flex justify-between w-full">
                  <div className="font-header font-semibold text-md text-green">{t('Credit Utilization')}</div>
                </div>
              </AccordionItemTrigger>
            </h2>
            <AccordionItemContent pb={4} px={0}>
              <div className={`w-full`}>
                <CreditUtilizationGraph />
                <GraphRangeSelector />
              </div>
            </AccordionItemContent>
          </AccordionItem>
        </AccordionRoot>
      }
    </div>
  )
}
